<template>
    <div class="leftPannel">
        <div class="leftPannel__container">
            <div class="leftPannel__wrapper" ref="scrollElement">
                <div class="leftPannel__head">
                    <div class="leftPannel__head_top">
                        <ul class="leftPannel__head_links">
                            <template v-for="item in headLinks" :key="item.id">
                                <li
                                    class="leftPannel__head_links_item"
                                    :class="{
                                        'leftPannel__head_links_item--active':
                                            item.id == headLinksActive,
                                        'leftPannel__head_links_item--disabled':
                                            item.id == 2
                                                ? getIsLoadingEpg
                                                : false,
                                    }"
                                    @click="toggleTvprogram(item.id)"
                                    v-if="
                                        isLoggedIn
                                            ? item.id == 1
                                                ? true
                                                : !notAcces
                                            : item.id == 1
                                    "
                                >
                                    <h3
                                        class="leftPannel__head_links_item_title"
                                    >
                                        {{ item.title }}
                                    </h3>
                                </li>
                            </template>
                        </ul>
                        <button
                            class="leftPannel__head_btn"
                            @click="closeLeftPanel"
                            v-if="!notAcces"
                            :title="`${$t('message.tvChannel.close')}`"
                            :aria-label="`${$t('message.tvChannel.close')}`"
                        >
                            <IClose />
                        </button>
                    </div>
                    <div class="leftPannel__head__categories">
                        <NewCategoriesSlider
                            v-show="headLinksActive == 1"
                            :isLoggedIn="isLoggedIn"
                        />
                        <NewTimeShiftSlider
                            v-show="headLinksActive == 2"
                            :days="days"
                            :currentDay="currentDay"
                            :isShow="headLinksActive == 2"
                            :activeSlideIndex="activeSlideIndex"
                            :isLoggedIn="isLoggedIn"
                            @clickEpg="clickEpg"
                        />
                    </div>
                </div>
                <div class="leftPannel__content" v-show="headLinksActive == 1">
                    <div
                        class="leftPannel__content_sckeleton"
                        v-if="getLoading"
                    >
                        <div class="sckeleton" v-for="i in 10" :key="i">
                            <div class="sckeleton_img">
                                <div class="sckeleton_img_load"></div>
                            </div>
                            <div class="sckeleton_content">
                                <div class="sckeleton_content_title"></div>
                                <div class="sckeleton_content_subtitle"></div>
                            </div>
                        </div>
                    </div>
                    <ul class="leftPannel__content__list" v-if="!getLoading">
                        <li
                            class="leftPannel__content__list_item"
                            v-for="item in getChanelsList"
                            :key="item.id"
                            :data-channel-id="item.id"
                        >
                            <div
                                :style="{
                                    '--progress-width': `${calculate(item)}%`,
                                }"
                                :class="{
                                    'channelItem--active': item.id == cid,
                                }"
                                class="channelItem"
                            >
                                <div class="channelItem__icon">
                                    <div class="channelItem__icon_img">
                                        <img
                                            :src="item?.icon"
                                            loading="lazy"
                                            :alt="item.name"
                                        />
                                    </div>
                                    <div
                                        class="channelItem__icon_lock"
                                        v-if="item.has_subscription === 0"
                                    >
                                        <Ilock />
                                    </div>
                                </div>
                                <div class="channelItem__content">
                                    <router-link
                                        :to="{
                                            name: 'channel',
                                            params: {
                                                id: item.id,
                                                lang: currentLang,
                                                slug: item?.slug,
                                            },
                                        }"
                                        class="channelItem__content_title"
                                    >
                                        {{ item.name }}
                                    </router-link>
                                    <h4 class="channelItem__content_subtitle">
                                        {{ item.program_name }}
                                    </h4>
                                    <div
                                        class="channelItem__content_description"
                                    >
                                        <!-- <h5
                                            class="channelItem__content_description_text"
                                            v-html="item.program_description"
                                        ></h5> -->
                                        <span
                                            @click.stop="moreInfoItem(item)"
                                            class="channelItem__content_description_more"
                                            >Подробнее</span
                                        >
                                    </div>
                                </div>
                                <div
                                    class="channelItem__fav channelItem__fav--outer"
                                    v-if="isLoggedIn"
                                    :class="{
                                        'channelItem__fav--active':
                                            item.is_favorited,
                                    }"
                                    @click.stop="toggleLike(item)"
                                >
                                    <iFav />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="leftPannel__content" v-show="headLinksActive == 2">
                    <div
                        class="leftPannel__content_sckeleton"
                        v-if="getIsLoadingEpg"
                    >
                        <div class="sckeleton" v-for="i in 10" :key="i">
                            <div class="sckeleton_img">
                                <div class="sckeleton_img_load"></div>
                            </div>
                            <div class="sckeleton_content">
                                <div class="sckeleton_content_title"></div>
                                <div class="sckeleton_content_subtitle"></div>
                            </div>
                        </div>
                    </div>
                    <ul
                        class="leftPannel__content__list"
                        v-if="!getIsLoadingEpg"
                    >
                        <li
                            class="leftPannel__content__list_item"
                            v-for="item in epg"
                            :key="item.id"
                            :data-program="item.id == timeDate.id"
                        >
                            <div
                                :class="{
                                    'channelItem--active':
                                        item.id == timeDate.id,
                                    'channelItem--disabled':
                                        new Date().getTime() / 1000 <
                                        Number(item.begin_time),
                                }"
                                @click="
                                    btnProgram(
                                        item.id,
                                        item.begin_time,
                                        item.end_time
                                    )
                                "
                                class="channelItem"
                            >
                                <div class="channelItem__icon">
                                    <div class="channelItem__icon_img">
                                        <img
                                            class="preview"
                                            v-if="item.preview"
                                            :src="item.preview"
                                            loading="lazy"
                                            :alt="item.name"
                                        />
                                        <img
                                            class="preview"
                                            v-if="!item.preview"
                                            :src="currentItem?.icon"
                                            loading="lazy"
                                            :alt="item.name"
                                        />
                                    </div>
                                    <div
                                        class="channelItem__icon_lock"
                                        v-if="
                                            new Date().getTime() / 1000 <
                                            Number(item.begin_time)
                                        "
                                    >
                                        <Ilock />
                                    </div>
                                </div>
                                <div class="channelItem__content">
                                    <div
                                        class="channelItem__content_programTime"
                                    >
                                        {{ fullTime(item.begin_time) }} -
                                        {{ fullTime(item.end_time) }}
                                    </div>
                                    <h4 class="channelItem__content_title">
                                        <span
                                            class="programName"
                                            v-html="item.name"
                                        ></span>
                                    </h4>
                                    <div
                                        class="channelItem__content_description channelItem__content_description--program"
                                    >
                                        <!-- <p
                                            class="channelItem__content_description_text"
                                            v-html="item.description"
                                        ></p> -->
                                        <span
                                            v-if="
                                                new Date().getTime() / 1000 >
                                                Number(item.begin_time)
                                            "
                                            @click.stop="moreInfoItem(item)"
                                            class="channelItem__content_description_more"
                                            >Подробнее</span
                                        >
                                    </div>
                                </div>
                                <div
                                    class="channelItem__fav channelItem__fav--live"
                                >
                                    <!-- <ILive v-if="item.id == timeDate.id" /> -->
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewCategoriesSlider from "./NewCategoriesSlider.vue";
import NewTimeShiftSlider from "./NewTimeShiftSlider.vue";
import IClose from "./icons/IClose.vue";
import Ilock from "./icons/Ilock.vue";
import iFav from "./icons/iFav.vue";
import ILive from "./icons/ILive.vue";
import ICurrentLive from "./icons/ICurrentLive.vue";
import { mapGetters } from "vuex";
import { favouriteChannel } from "../../Api";
import { converter } from "../../converter.js";

export default {
    name: "LeftPannel",
    components: {
        NewCategoriesSlider,
        IClose,
        NewTimeShiftSlider,
        Ilock,
        iFav,
        ICurrentLive,
        ILive,
    },
    emits: [
        "closeLeftPanel",
        "toggleTvprogram",
        "clickEpg",
        "toggleLike",
        "moreInfoItemActive",
    ],
    props: [
        "headLinks",
        "headLinksActive",
        "isLoggedIn",
        "days",
        "currentDay",
        "activeSlideIndex",
        "epg",
        "currentItem",
        "timeDate",
        "notAcces",
    ],
    watch: {
        headLinksActive() {
            this.$nextTick(() => this.scrollToCurrentChannel());
        },
        getChanelsList(value) {
            this.$nextTick(() => this.scrollToCurrentChannel());
            
        },
    },
    computed: {
        ...mapGetters(["getChanelsList", "getLoading", "getIsLoadingEpg"]),
        currentLang() {
            return this.$i18n.locale === "ru" ? "" : "uz";
        },
        cid() {
            return this.$router.currentRoute.value.params.id;
        },
    },
    mounted() {
        if (this.getChanelsList.length) {
            this.scrollToCurrentChannel();
        }
    },
    methods: {
        moreInfoItem(item) {
            this.$emit("moreInfoItemActive", item);
        },

        closeLeftPanel() {
            this.$emit("closeLeftPanel");
        },
        toggleTvprogram(id) {
            this.$emit("toggleTvprogram", id);
        },
        clickEpg(item, index) {
            this.$emit("clickEpg", item, index);
        },
        btnProgram(pid, time, endTime) {
            this.$emit("btnProgram", pid, time, endTime);
        },
        async toggleLike(chanel) {
            if (chanel.is_favorited === 0) {
                await favouriteChannel("like", chanel.id);
                this.$store.commit("SET_STATIC_FAVOURITE", chanel.id);
            } else {
                await favouriteChannel("dislike", chanel.id);
                this.$store.commit("REMOVE_STATIC_FAVOURITE", chanel.id);
            }
            this.$store.commit("SET_FAVORITED_CHANELS", chanel.id);
            this.$emit("toggleLike", chanel);
        },
        fullTime(s) {
            return converter(s)[0];
        },
        calculate(item) {
            const currentTime = (new Date().getTime() / 1000).toFixed(0);
            const beginTime = item.program_begin_time;
            const endTime = item.program_end_time;
            const duration = endTime - beginTime;
            const postionTime = endTime - currentTime;
            const result = 100 - (postionTime * 100) / duration;

            return result;
        },
        scrollToCurrentChannel() {
            const scrollElement = this.$refs.scrollElement;
            if (!scrollElement) return;

            const targetElement =
                this.headLinksActive == 1
                    ? document.querySelector(`[data-channel-id="${this.cid}"]`)
                    : document.querySelector(`[data-program="true"]`);

            if (!targetElement) return;

            scrollElement.scrollTo({
                top: targetElement?.offsetTop - 178,
                behavior: "smooth",
            });
        },
    },
};
</script>
